<template>
  <div class="mobile-wrapping">
    <header>
      <div class="mobile-logo">
        <img :src="logoUrl" class="mobile-logo-image" />
      </div>
    </header>

    <div id="main">
      <div style="align-content: center;justify-content: center;">
        <div class="mobile-payment-user-info">
          <el-row :gutter="2" align="middle" class="mobile-payment-user-info-row">
            <el-col :span="8">
              <div>
                <el-avatar
                  :size="60"
                  :src="userInfo.avatar"
                  class="user-info-avatar"
                ></el-avatar>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="user-info">
                <div>{{ $t('recharge.payment.nickName') }}:</div>
                <div>{{ $t('recharge.payment.uid') }}:</div>
                <div>{{ $t('recharge.payment.package') }}:</div>
              </div>
            </el-col>

            <el-col :span="10">
              <div class="user-info">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo.uid }}</div>
                <div>{{ productInfo.diamond }} {{ $t('recharge.payment.diamonds') }}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="mobile-payment-divider"></div>

        <div class="mobile-payment-pay">
          <el-row :gutter="2" align="small">
            <div class="mobile-payment-pay-content">
              <span class="pc-payment-title"> {{ $t('recharge.payment.btn_return') }}</span>
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content=""
                placement="bottom"
              >
                <i class="el-icon-question"></i>
              </el-tooltip> -->
            </div>
          </el-row>

          <el-row :gutter="2" align="middle">
            <div class="mobile-payment-pay-list">
              <div
                style="float:left"
                v-for="(pay, index) in payTypeList"
                :key="index"
                class="mobile-payment-pay-item"
                @click="checkPayment(index)">
                <el-image :src="pay.mIcon" :class="pay.type === payType ? 'img-check' : 'img-opacity'"></el-image>
              </div>
            </div>
          </el-row>

          <!-- check -->
          <el-row :gutter="2" align="middle">
            <div style="float:left" class="mobile-payment-check-info">
              <i class="el-alert__icon el-icon-success"></i>
              <span>{{ payTitle }}</span>
            </div>
          </el-row>

          <!-- 价格 -->
          <el-row>
            <div class="mobile-payment-price">
              <span>{{ $t('recharge.payment.amount') }}: {{ productInfo.price }} USD</span>
            </div>
          </el-row>

          <!-- 按钮 -->
          <el-row>
            <div class="mobile-confirm-btn-content">
              <el-button
                class="mobile-confirm-btn"
                :disabled="submitBtnDisable"
                @click="submit"
                >{{ $t('recharge.payment.btn_buy') }}</el-button
              >
            </div>
          </el-row>

          <!-- return -->
          <el-row>
            <div class="mobile-result-return-left">
              <el-button @click="back" type="primary" size="medium">{{ $t('recharge.payment.btn_return') }}</el-button
              >
            </div>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 底图 -->
    <div class="mobile-main-image">
      <img :src="backgourpMain" />
    </div>

    <!-- pay 用户信息 -->
    <el-dialog
      :title="$t('recharge.payment.pay_user_info')"
      :visible="payUserInfoVisible"
      :before-close="payUserInfoDialogClose"
      width="99%"
      append-to-body
      >
        <el-form ref="payUserForm" :model="payUserInfoForm" label-width="90px" :rules="payUserInfoFormRules">
          <el-form-item prop="name" :label="$t('recharge.payment.name')">
          <el-input v-model="payUserInfoForm.name" maxlength="10" />
        </el-form-item>

        <el-form-item prop="phone" :label="$t('recharge.payment.phone')" type="tel">
          <el-input v-model="payUserInfoForm.phone"/>
        </el-form-item>

        <el-form-item prop="email" :label="$t('recharge.payment.email')" type="email">
          <el-input v-model="payUserInfoForm.email"/>
        </el-form-item>

        <el-form-item>
          <el-button type="success" :disabled="infoSubmitBtnDisable" @click="submit">{{ $t('recharge.payment.btn_user_info_buy') }}</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import logo from '@/assets/images/recharge/mobile/logo.png'
import backgourpMain from '@/assets/images/recharge/mobile/backgourp_main.png'
import { order } from '@/api/payment'
import paymentConfig from '@/util/payment'
import {redirect} from '@/util/order-redirect'
import collect from 'collect.js'
import inArray from 'locutus/php/array/in_array'

export default {
  name: 'RechargePaymentMobile',
  data () {
    return {
      logoUrl: logo,
      backgourpMain: backgourpMain,
      submitBtnDisable: false,
      infoSubmitBtnDisable: false, // pay info 购买按钮
      payUserInfoVisible: false,
      payForm: {
        actionUrl: '',
        params: []
      },
      buyForm: {
        uid: '',
        productId: ''
      },
      payUserInfoForm: {
        name: '',
        phone: '',
        email: ''
      },
      userInfo: {
        uid: '',
        nickname: '',
        avatar: ''
      },
      productInfo: {
        diamond: '',
        price: '',
        productId: ''
      },
      payType: 2,
      payTitle: 'BTC',
      payTypeList: [],
      isTest: false,

      payUserInfoFormRules: {
        email: [
          {
            required: true,
            trigger: 'blur',
            message: 'email requied!'
          },
          {
            min: 1,
            max: 128,
            type: 'email',
            trigger: 'blur',
            message: 'email format'
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            message: 'phone requied!'
          },
          {
            min: 1,
            max: 30,
            type: 'string',
            trigger: 'blur',
            message: 'phone format'
          }
        ],
        name: [
          {
            required: true,
            trigger: 'blur',
            message: 'name requied!'
          },
          {
            min: 1,
            max: 50,
            type: 'string',
            trigger: 'blur',
            message: 'name format!'
          }
        ]
      }
    }
  },
  mounted () {
    this.payTypeList = paymentConfig.typeList

    let params = this.$route.params || {}

    this.userInfo = params.userInfo
    this.buyForm = params.buyForm
    this.productInfo = params.productInfo
    this.isTest = params.isTest

    if (!params.buyForm) {
      this.$router.push({ name: 'Recharge' })
    } else {
      if (params.userInfo.avatar) {
        let avatar = params.userInfo.avatar.split(':')
        let avatarId = avatar[1] || '1'

        if (params.userInfo.avatar.startsWith('default')) {
          params.userInfo.avatar = require('@/assets/images/avatar/user/player_head_' + avatarId + '.jpg')
        }

        if (params.userInfo.avatar.startsWith('special')) {
          params.userInfo.avatar = require('@/assets/images/avatar/user/player_head_' + avatarId + '.png')
        }
      }
    }

    const collection = collect(this.payTypeList)

    this.payTypeList = collection.filter((value, key) => {
      if (value.product && value.product.length > 0) {
        if (!this.isTest && value.isDev) {
          return false
        }

        if (this.productInfo.productId && inArray(this.productInfo.productId, value.product)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }).all()

    const defaultPayType = collect(this.payTypeList).first()
    this.payType = defaultPayType.type
    this.payTitle = defaultPayType.title
  },
  methods: {
    back () {
      this.$router.push({ name: 'Recharge' })
    },

    checkPayment (index) {
      this.payType = this.payTypeList[index].type
      this.payTitle = this.payTypeList[index].title
    },

    payUserInfoDialogClose () {
      this.submitBtnDisable = false
      this.infoSubmitBtnDisable = false
      this.payUserInfoVisible = false
      this.$refs['payUserForm'].resetFields()
    },

    submit () {
      this.submitBtnDisable = true
      this.infoSubmitBtnDisable = true

      switch (this.payType) {
        case 3:
        case 4:
          if (this.payUserInfoForm.email === '' || this.payUserInfoForm.name === '' || this.payUserInfoForm.phone === '') {
            this.payUserInfoVisible = true
            this.submitBtnDisable = true
            this.infoSubmitBtnDisable = false
            return
          } else {
            this.$refs['payUserForm'].validate((valid) => {
              if (!valid) {
                this.$notify.error({
                  title: 'valid faild',
                  message: 'valid faild'
                })
                return false
              }
              this.infoSubmitBtnDisable = false
            })
          }

          break
      }

      let params = {
        type: this.payType,
        uid: this.buyForm.uid,
        productId: this.buyForm.productId,
        lang: 'en_us',
        payUserInfo: this.payUserInfoForm
      }

      order(params)
        .then(({ data, msg }) => {
          if (data.orderInfo) {
            this.payForm = data.orderInfo
            redirect(this.payType, this.payForm)
          } else {
            this.$message({
              showClose: true,
              message: msg,
              type: 'error'
            })
          }
          this.submitBtnDisable = false
          this.infoSubmitBtnDisable = false
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: 'Purchase Failed',
            type: 'error'
          })
          this.submitBtnDisable = false
          this.infoSubmitBtnDisable = false
        })
    }
  }
}
</script>

<style>
  @media screen and (max-width: 750px) {
    .el-message {
      width: 60% !important;
      min-width: 320px;
    }
  }

.mobile-uid-input-control .el-input-group__prepend {
  background-color: #4079b9;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  border: none;
}
.el-form-item__error {
  text-align: center;
  right: 0;
}

.mobile-product-list .el-row {
  margin-bottom: 20px; /* no*/
}

.mobile-product-list .el-card {
  border: 0px;
}

.user-info-avatar {
  border: groove 2px #5786bf;
}

.mobile-payment-pay .mobile-payment-check-info .el-icon-success {
  width: 27px;
  height: 27px;
  color: #32c77e;
}

.mobile-product-list .is-disabled {
  color: #fff;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  width: 340px;
  height: 79px;
}
.mobile-product-list .is-disabled:hover {
  color: #fff;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  width: 340px;
  height: 79px;
}

.mobile-confirm-btn-content .el-button:hover {
  color: #fff;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  background-size: 100% 100%;
  width: 617px;
  height: 101px;
  background-color: #9dffcf;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-wrapping {
  background: url("~@/assets/images/recharge/mobile/backgourp_payment.jpg")
    repeat-x;
  overflow: hidden;
  height: 100%;
  position: absolute;
  left: 0px;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}

header {
  width: 100%;
  height: 100px;
  position: absolute;
  background-color: #0a0c11;
  z-index: 5;
  top: 0;
  text-align: center;
}

.mobile-logo {
  display: inline-block;
  margin-top: 2px;
  margin-bottom: 2px;
}

.mobile-logo-image {
  width: 277px;
  height: 108px;
}

#main {
  width: 100%;
  top: 100px;
  position: absolute;
  z-index: 10;
}

.mobile-payment-user-info {
  width: 100%;
  height: 280px;
}

.mobile-payment-user-info-row {
  width: 100%;
  height: 280px;
  justify-content: center;
  align-items: center;
  display: -webkit-flex;
}

.mobile-payment-user-info .user-info {
  float: left;
  text-align: left;
  color: #ffffff;
}

.mobile-payment-user-info .user-info div {
  font-family: SourceHanSansCN-Regular;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-payment-divider {
  display: inline-block;
  background: url("~@/assets/images/recharge/mobile/payment-divider.png") center
    center no-repeat;
  width: 90%;
  height: 2px;
}

.mobile-payment-pay {
  display: inline-block;
  width: 84%;
  height: 360px;
}

.mobile-payment-pay-content {
  color: #ffffff;
  float: left;
  margin-top: 65px;
}

.mobile-payment-pay-content .pc-payment-title {
  font-family: SourceHanSansCN-Regular;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-payment-pay-list {
  margin-top: 40px;
}

.mobile-payment-pay-item {
  width: 196px;
  height: 51px;
  background-color: #ffffff;
  border-radius: 6px;
  margin-right: 12px;
  margin-top: 12px;
}

.mobile-payment-pay-item .img-opacity {
  background-color: white;
  border-style:solid;
	border-width:3px;
  border-color: white;
  filter:brightness(18%);
}

.mobile-payment-pay-item .img-check {
  background-color: rgb(50,199,126);
  cursor:pointer;
  border: 3px solid rgb(50,199,126);
  position: relative;
  transition: all 0.5s ease;
}

.mobile-payment-pay-item .img-check:after {
  content: "✓";
  display: block;
  height: 0px;
  width: 0px;
  position: absolute;
  bottom: 0;
  right: 0;
  color:#fff;
  /**对号大小*/
  font-size: 1px;
  line-height: 3px;
  border: 10px solid;
  border-color: transparent  rgb(50,199,126)  rgb(50,199,126) transparent;
}

.mobile-payment-pay .mobile-payment-check-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 60px;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-payment-pay .mobile-payment-price {
  margin-top: 61px;
  font-family: SourceHanSansCN-Regular;
  font-size: 34px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-confirm-btn-content {
  margin-top: 60px;
}

.mobile-confirm-btn {
  margin-top: 45px;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  background-size: 100% 100%;
  width: 617px;
  height: 101px;
  background-color: #9dffcf;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 30px;
  border-radius: 8px;
  border: none;
} /* no*/

.mobile-result-return-left {
  float: left;
  margin-top: 40px;
  margin-left: 5px;
}

.mobile-main-image {
  position: fixed;
  bottom: -100px;
}

.mobile-main-image img {
  opacity: 0.5;
  width: 100%;
}

footer {
  height: 76px;
  /* background:yellow; */
  width: 100%;
  position: absolute;
  z-index: 200;
  bottom: 20px;
  text-align: center;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/components/payment/mobile.vue